import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { pageUrls } from 'src/app/configuration/pages';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  imports: [SharedModule],
})
export class MessageBoxComponent {
  readonly isValidToken = input.required<boolean>();
  readonly isSubmitSuccess = input.required<boolean>();

  constructor(private readonly router: Router) {}

  /**
   * Redirect to password forgot page.
   */
  redirectToPasswordForgot() {
    this.router.navigateByUrl(`/${pageUrls.passwordForgot}`, { replaceUrl: true });
  }

  /**
   * Redirect to login page.
   */
  redirectToLogin() {
    this.router.navigateByUrl(`/${pageUrls.login}`, { replaceUrl: true });
  }
}
